import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { ROUTES } from '@/lib/constants';

const ONBOARDING_ALLOWED = [
  ROUTES.ONBOARDING,
  '/dashboard/settings/coverage',
  '/dashboard/settings/delivery-zones',
  '/dashboard/settings/routes',
  '/dashboard/settings/pricing-routes',
  '/dashboard/drivers',
];

export function CarrierGuard({ children }: { children: React.ReactNode }) {
  const { user } = useAuth();
  const location = useLocation();

  // Not a carrier — pass through
  if (user?.role !== 'carrier') return <>{children}</>;

  // Active carrier — full access
  if (user.carrier_status === 'active') return <>{children}</>;

  // Incomplete carrier — allow onboarding pages only
  if (ONBOARDING_ALLOWED.some((p) => location.pathname.startsWith(p))) {
    return <>{children}</>;
  }

  return <Navigate to={ROUTES.ONBOARDING} replace />;
}
